import React, { Component } from 'react'
import { Badge } from '@softwaredev_cegeka/stix-core'

import { getStatusName } from 'src/utils'
import styles from './tableLegend.module.scss'

class TableLegend extends Component {
    render() {
        const { statusMap } = this.props

        const badges = Object.entries(statusMap).map(
            ([statusName, variant]) => (
                <Badge
                    className={styles.badge}
                    key={statusName}
                    size="tiny"
                    variant={variant}
                >
                    {getStatusName(statusName)}
                </Badge>
            )
        )

        return <div className={styles.legend}>{badges}</div>
    }
}

export default TableLegend
